export type Dict<T = any> = Record<string, T>;

export const objectKeys = <T extends Dict>(obj: T) =>
  Object.keys(obj) as unknown as (keyof T)[];
